import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@codeandweb/ngx-translate';

@Injectable({providedIn: 'root'})
@Pipe({name: 'yesno'})
export class YesNoPipe implements PipeTransform {

	constructor(private translateService: TranslateService) {}

	transform(value: boolean): string {
		return this.translateService.instant(value ? 'common.yes' : 'common.no');
	}
}
